module.exports = __webpack_public_path__ + "static/media/wa.caf4a59f.jpg";